/* eslint-disable */
import Axios from "axios";
import qs from "query-string";
import {
  CLIENT_CONFIG,
  DOWNLOAD_TRANSACTIONS,
  FORGOT_PASSWORD,
  LOGIN,
  SIGNUP,
  SSO_LOGIN,
} from "app/api/ApiEndpoints";
import { getTenantName } from "../utils";

const baseAPIUrl = process.env.REACT_APP_API_SERVER;
const excludeAuthURLS = [LOGIN, SIGNUP, FORGOT_PASSWORD, SSO_LOGIN];
const excludeConfigURL = [CLIENT_CONFIG];
let tenantName = getTenantName(qs.parse(location.search));

if (!tenantName && localStorage.getItem("currentTenantName")) {
  tenantName = localStorage.getItem("currentTenantName");
}

const axiosInitialParams = {
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};

const axios = Axios.create({
  baseURL: baseAPIUrl,
  axiosInitialParams,
});

function errorHandler(error) {
  if (!error.response) {
    return {
      response: { cors: true },
    };
  }
  if (error.response.status === 401 && error?.response.config?.url !== LOGIN) {
    let url = tenantName
      ? "/auth/login?tenant-name=" + tenantName
      : "/auth/login";
    if(window.sso_back_button_url) {
      url = window.sso_back_button_url;
    }
    if(window.tokenVerifyInterval) {
      clearInterval(window.tokenVerifyInterval);
    }
    window.location = url;

    localStorage.clear();
  }
  return Promise.reject(error);
}

axios.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error),
);

export const useGet = async ({ url, responseType, token }) => {
  const tenantName = localStorage.getItem("currentTenantName");
  return await axios
    .get(
      url,
      excludeConfigURL.includes(url)
        ? {
            headers: {
              tenantName: tenantName,
            },
          }
        : responseType
        ? {
            responseType: responseType,
            headers: {
              Authorization: token,
              tenantName: tenantName,
            },
          }
        : {
            headers: {
              Authorization: token,
              tenantName: tenantName,
            },
          },
    )
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject(error);;
      }
    });
};

export const usePost = async ({ url, data, token, customHeaders }) => {
  const tenantName = localStorage.getItem("currentTenantName");
  let configs = excludeAuthURLS.includes(url)
    ? {
      headers: {
        tenantName: tenantName,
      },
    }
    : url === DOWNLOAD_TRANSACTIONS
      ? {
        responseType: "blob",
        headers: {
          Authorization: token,
          tenantName: tenantName,
        },
      }
      : {
        headers: {
          Authorization: token,
          tenantName: tenantName,
        },
      };

  if (customHeaders) {
    if (configs.headers) {
      Object.keys(customHeaders).map(customHeaderKey => configs.headers[customHeaderKey] = customHeaders[customHeaderKey]);
    }
  }

  return await axios
    .post(
      url,
      data,
      configs
    )
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject(error);;
      }
    });
};

export const useDelete = async ({ url, token }) => {
  const tenantName = localStorage.getItem("currentTenantName");
  return await axios
    .delete(url, {
      headers: {
        Authorization: token,
        tenantName: tenantName,
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject(error);;
      }
    });
};

export const usePut = async ({ url, data, token }) => {
  const tenantName = localStorage.getItem("currentTenantName");
  return await axios
    .put(
      url,
      data,
      excludeAuthURLS.includes(url)
        ? {
            headers: {
              tenantName: tenantName,
            },
          }
        : {
            headers: {
              Authorization: token,
              tenantName: tenantName,
            },
          },
    )
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject(error);;
      }
    });
};
